import { CircleUser } from 'lucide-react';
import { useIntl } from '@/core/i18n/use-intl';
import { PageContainer, PageTitle } from '@/shared/components/layout';
import { AccountForm } from '../components/account-form';

export function MyAccount() {
  const { t } = useIntl();

  return (
    <PageContainer>
      <PageTitle icon={CircleUser} title={t('auth.myAccount')} />
      <AccountForm />
    </PageContainer>
  );
}
